import React from 'react'
import './experiences.css'
import {BsPatchCheckFill} from 'react-icons/bs'
const experiences = () => {
  return (
    <section id='experiences'>
      
      <h5></h5>
      <h2>Compétences</h2>

      <div className='container experience__container'>
      <div className='experience__frontend'>
        {/* ---------------------------------soft skills----------------------------------------------------- */}
          <div className='experience__head'>
            <h3>Soft Skills</h3>
          </div>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div >
                <h4>Ambitieux </h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Sens de l'écoute et d'analyse</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Impliqué  </h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Autonome</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Volontaire</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Force de proposition</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Proactif</h4>
                <small className='text-light'></small>
              </div>
              

            </article>
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4></h4>
                <small className='text-light'></small>
              </div>
              

            </article> */}
          </div>
        </div>
        <div className='experience__frontend'>
          {/* ***************************Mathématiques ****************************** */}
          {/* •	Algèbre linéaire•	Probabilité•	Statistiques paramétriques•	Statistiques non paramétriques
          •	Statistiques bayésienne•	Analyse univarié et multivarié•	Matrices  */}
          <h3>Statistiques pour l'informatique décisionnelle</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Analyse descriptive</h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Analyse prédictive</h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Economie comportementale</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Statistiques paramétriques</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Statistiques non paramétriques</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Statistiques bayésiennes</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Gestion: Business intelligence</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Modélisation économétrique du risque</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Marketing quantitatif</h4>
                <small className='text-light'></small>
              </div>
              

            </article>
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
              

            </article> */}
          </div>
        </div>
   
        <div className='experience__frontend'>
          {/* ***************************data analysis ****************************** */}
          {/* develop python libraries for data analysis  */}
          <h3>Outils Data Analysis / Data visualization / BI</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Python</h4>
                <small className='text-light'>Avancé</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>R</h4>
                <small className='text-light'>Intermédiaire</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Microsoft Excel</h4>
                <small className='text-light'>Intermédiaire</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Tableau</h4>
                <small className='text-light'>Avancé</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Power BI</h4>
                <small className='text-light'>Intermédiaire</small>
              </div>
              

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>SQL</h4>
                <small className='text-light'>Avancé</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>QlikView</h4>
                <small className='text-light'>Intermédiaire</small>
              </div>

            </article>
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Tableau</h4>
                <small className='text-light'></small>
              </div>
              

            </article> */}
            
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>SAS</h4>
                <small className='text-light'>Intermédiaire</small>
              </div>
              

            </article>
          </div>
        </div>
        <div className='experience__frontend'>
          {/* ---------------------------Machine Leaning and Deep Leaning------------------------------------------ */}
          <h3>Outils Machine Leaning et Deep Leaning</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Pytorch</h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Keras</h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Jupyter Notebook/Google Colab</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Scikit-learn</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Pandas</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>NumPy</h4>
                <small className='text-light'></small>
              </div>

            </article>
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Matplotlib et Seaborn</h4>
                <small className='text-light'></small>
              </div>

            </article> */}
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
              

            </article> */}
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>
              

            </article> */}
          </div>
        </div>













        <div className='experience__backend'>
          {/* ----------------------------------MLOps----------------------------------- */}
        <h3>MLOps (écosystème python)</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Docker</h4>
                <small className='text-light'>Débutant</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>flask</h4>
                <small className='text-light'>Débutant</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Azure</h4>
                <small className='text-light'>Débutant</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Heroku</h4>
                <small className='text-light'>Débutant</small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>gunicorn</h4>
                <small className='text-light'>Débutant</small>
              </div>
            </article>
            {/* <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>Postman </h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article> */}
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>GitHub actions</h4>
                <small className='text-light'>Débutant</small>
              </div>
            </article>
          </div>
        </div>
        {/* <div className='experience__frontend'>
          <h3>Programmation web</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>HTML5</h4>
                <small className='text-light'></small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>CSS3</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'></small>
              </div>

            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icons'/>
              <div>
                <h4>React</h4>
                <small className='text-light'></small>
              </div>

            </article>
          
          </div>
        </div> */}
      </div>
    </section>
  )
}

export default experiences